<template>
  <div class="hello">
    <v-header :active.sync="active" ref="mychild"></v-header>
    <div>
      <router-view></router-view>
    </div>
     <Foot ></Foot>
  </div>
</template>

<script>
import VHeader from '../components/Header.vue'
import Foot from '../components/Foot.vue'

export default {
  components: {
    VHeader,
    Foot
  },
  data () {
    return {
      active: 'Home'
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/HelloWorld.vue